import { render, staticRenderFns } from "./BookingDealTableSection.vue?vue&type=template&id=40850dfa&lang=pug&"
import script from "./BookingDealTableSection.vue?vue&type=script&lang=js&"
export * from "./BookingDealTableSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports